import "tempusdominus-bootstrap-4"
import "tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.css"

$.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
  icons: {
    up: "fas fa-arrow-up",
    down: "fas fa-arrow-down",
    previous: "fas fa-chevron-left",
    next: "fas fa-chevron-right"
  }
})

$(function() {
  $(".datepicker-component").datetimepicker({ format: "L" })
})
